export default __webpack_public_path__ + "static/media/righteye.aeca0ee6.svg";